/* schedule.js */

"use strict";
const ScheduleComponent = require("@gluenetworks/schedule_component");
const CmdbNotificationComponent = require("../../libs/CmdbNotificationComponent");
const uiCore = require("@gluenetworks/steve_ui_core");
const EventEmitter = require("events").EventEmitter;
const {
    Control: {
        Action: {Button},
        Boolean: {InputCheckbox},
    },
} = uiCore;
const _ = require("lodash");

class Schedules extends EventEmitter {
    constructor(dataSyncConfigEntity, logger, userSession) {
        super();
        this._isValid = true;
        this._defaultSchedule = ScheduleComponent.defaultValue({
            allowOne: false,
            allowRepeat: true,
            pollOnly: false,
            availOnly: true,
        });
        this._xdDataSyncConfigEntity = dataSyncConfigEntity;
        this._valueChange = this._valueChange.bind(this);
        this._logger = logger;
        this._userSession = userSession;
    }

    whenReady() {
        return Promise.all([
            this._scheduleFrequencyComponent.renderer.render(),
            this._notificationComponent.renderer.render(),
        ]);
    }

    _createLinkingAndSyncingScheduleTab() {
        this._enableDisableSchedulesCheckbox = new InputCheckbox({
            label: "Enable Scheduled Syncing of Devices and Sites",
            labelShown: true,
            value: false, // Disabled By Default
            darkTheme: true,
        });

        this._scheduleFrequencyComponent = new ScheduleComponent(undefined, {
            allowOne: false,
            allowRepeat: true,
            pollOnly: false,
            availOnly: true,
            disabled: false,
            noStartingEnding: true,
            repeatOption: false,
        });
        this._scheduleFrequencyComponent.theme = "dark";

        this._notificationComponent = new CmdbNotificationComponent(
            this._logger,
            this._userSession,
            {darkTheme: true, title: "Notify on Completion", workType: null},
            this._xdDataSyncConfigEntity.getScheduleWorkInput()
        );

        this._previewButton = new Button({
            label: "Preview Syncing Now",
            darkTheme: true,
        });

        this._runButton = new Button({
            label: "Run Syncing Now",
            darkTheme: true,
        });

        this._downloadButton = new Button({
            label: "Download Last Report",
            darkTheme: true,
            visible: false,
        });
        this._lastSyncingMsg = document.createElement("span");
        this._lastSyncingMsg.classList.add("last-sync-status");

        this.scheduleButtonContainer = document.createElement("div");
        this.scheduleButtonContainer.classList.add("schedule-buttons-container");

        this.scheduleButtonContainer.appendChild(this._previewButton._renderer._rootElem);
        this.scheduleButtonContainer.appendChild(this._runButton._renderer._rootElem);
        this.scheduleButtonContainer.appendChild(this._downloadButton._renderer._rootElem);
        this.scheduleButtonContainer.appendChild(this._lastSyncingMsg);

        // this._enableDisableSchedules();
    }

    _getLinkingSyncingContent() {
        const _tabMainContent = document.createElement("div");
        _tabMainContent.classList.add("content-main");

        this._enableDisableSchedulesCheckbox.setValue(
            this._xdDataSyncConfigEntity.getScheduleEnabled() || false
        );

        this._setInitialSchedule();

        _tabMainContent.appendChild(this._enableDisableSchedulesCheckbox._renderer._rootElem);
        _tabMainContent.appendChild(this._scheduleFrequencyComponent._renderer._rootElem);
        _tabMainContent.appendChild(this.scheduleButtonContainer);
        _tabMainContent.appendChild(this._notificationComponent.renderer.rootElement);
        return _tabMainContent;
    }

    _enableDisableSchedules() {
        const isScheduleEnabled = this._enableDisableSchedulesCheckbox.getValue();
        this._scheduleFrequencyComponent.setDisabledSchedule(!isScheduleEnabled);
        this._notificationComponent.setDisabled(!isScheduleEnabled);
        this._downloadButton.setDisabled(!this._enableDisableSchedulesCheckbox.getValue());
    }

    _registerListeners() {
        this._enableDisableSchedulesCheckbox.on("UserValue", this._valueChange);
        this._scheduleFrequencyComponent.on("UserValue", this._valueChange);
        this._previewButton.on("UserClick", (this._previewWork = this._previewWork.bind(this)));
        this._runButton.on("UserClick", (this._runWork = this._runWork.bind(this)));
        this._downloadButton.on(
            "UserClick",
            (this._downloadLastWork = this._downloadLastWork.bind(this))
        );
        this._registerNotificationComponentListeners();
    }

    _unRegisterListeners() {
        this._enableDisableSchedulesCheckbox.removeListener("UserValue", this._valueChange);
        this._scheduleFrequencyComponent.removeListener("UserValue", this._valueChange);
        this._previewButton.removeListener("UserClick", this._previewWork);
        this._runButton.removeListener("UserClick", this._runWork);
        this._downloadButton.removeListener("UserClick", this._downloadLastWork);
        this._unRegisterNotificationComponentListeners();
    }

    _registerNotificationComponentListeners() {
        this._notificationComponent.on(
            "ValidationStateChanged",
            (this._onValidationStateChanged = this._onValidationStateChanged.bind(this))
        );
        this._notificationComponent.on("EmailListWasChanged", this._valueChange);
    }

    _unRegisterNotificationComponentListeners() {
        this._notificationComponent.removeListener(
            "ValidationStateChanged",
            this._onValidationStateChanged
        );
        this._notificationComponent.removeListener("EmailListWasChanged", this._valueChange);
    }

    _valueChange() {
        this._enableDisableSchedules();
        const values = this._getValues();
        const notifWorkInp = this._notificationComponent.getNotificationsWorkInputObject();
        if (
            !notifWorkInp.notifyMe &&
            (!this._xdDataSyncConfigEntity.pristineProperties.scheduleWorkInput ||
                !this._xdDataSyncConfigEntity.pristineProperties.scheduleWorkInput.notifyMe)
        ) {
            notifWorkInp.notifyMe = _.get(
                this._xdDataSyncConfigEntity,
                "pristineProperties.scheduleWorkInput.notifyMe"
            );
        }
        this._xdDataSyncConfigEntity.setScheduleEnabled(values.enable);
        this._xdDataSyncConfigEntity.setSchedule(values.schedule);
        const scheduleWorkInput = Object.assign({}, notifWorkInp, {
            dataProvider: "claroty",
            dataProviderProduct: "xdome",
        });
        this._xdDataSyncConfigEntity.setScheduleWorkInput(scheduleWorkInput);

        this.emit("ValueChange", values);
    }

    _onValidationStateChanged(isValid) {
        this._isValid = isValid;
    }

    _previewWork() {
        this.emit("PreviewWork");
    }

    _runWork() {
        this.emit("RunWork");
    }

    _downloadLastWork() {
        this.emit("DownloadLastWork");
    }

    _validateLinkingSyncingTab() {
        return this._isValid;
    }

    _setDefaultSchedule() {
        this._scheduleFrequencyComponent.setSchedule(this._defaultSchedule, false);
    }

    _getSchedule() {
        if (this._scheduleFrequencyComponent.getSchedule()) {
            return this._scheduleFrequencyComponent.getSchedule();
        } else if (this._enableDisableSchedulesCheckbox.getValue()) {
            return this._defaultSchedule;
        }
        return this._xdDataSyncConfigEntity.getSchedule();
    }

    _setInitialSchedule() {
        if (!_.isEmpty(this._xdDataSyncConfigEntity.getSchedule())) {
            this._scheduleFrequencyComponent.setSchedule(
                this._xdDataSyncConfigEntity.getSchedule() || {}
            );
        } else if (this._xdDataSyncConfigEntity.getScheduleEnabled()) {
            this._setDefaultSchedule();
        }
    }

    _getValues() {
        const isScheduleEnabled = this._enableDisableSchedulesCheckbox.getValue();
        const scheduleValues = {
            enable: isScheduleEnabled,
            schedule: this._getSchedule(),
        };
        return scheduleValues;
    }

    _setValues(scheduleValues, setByUser = false) {
        this._enableDisableSchedulesCheckbox.setValue(scheduleValues.enable);
        this._scheduleFrequencyComponent.setSchedule(scheduleValues.schedule, setByUser);
    }

    _resetValues() {
        this._enableDisableSchedulesCheckbox.setValue(
            this._xdDataSyncConfigEntity.pristineProperties.scheduleEnabled || false
        );
        this._setInitialSchedule();

        const scheduleWorkInput = this._xdDataSyncConfigEntity.pristineProperties.scheduleWorkInput;
        this._notificationComponent.resetCmdbNotificationComponent({
            value: scheduleWorkInput,
        });
    }

    shutdown() {
        const prom = [
            this._scheduleFrequencyComponent.shutdown(),
            this._enableDisableSchedulesCheckbox.shutdown(),
            this._downloadButton.shutdown(),
            this._previewButton.shutdown(),
            this._runButton.shutdown(),
        ];

        return Promise.all(prom).then(() => {
            this._defaultSchedule = undefined;
            this._lastSyncingMsg = undefined;
            this._scheduleFrequencyComponent = undefined;
            this._enableDisableSchedulesCheckbox = undefined;
            this._downloadButton = undefined;
            this._previewButton = undefined;
            this._runButton = undefined;
            this.scheduleButtonContainer = undefined;
        });
    }

    setDataSyncEntity(ety) {
        this._xdDataSyncConfigEntity = ety;
    }
}

module.exports = Schedules;
